import { AnswerSelectProps, IKeyedQuestion } from './AnswerSelect';
import { ContainAssistanceMode } from './Container/ContainAssistanceMode';
import { ContainChooseDate } from './Container/ContainChooseDate';
import { ContainConfirmSession } from './Container/ContainConfirmSession';
import { ContainCounsellors } from './Container/ContainCounsellors';
import { ContainLanguage } from './Container/ContainLanguage';
import { ContainPhoneLanguage } from './Container/ContainPhoneLanguage';
import { ContainRegion } from './Container/ContainRegion';
import { ContainRegionInstantHelp } from './Container/ContainRegionInstantHelp';
import { ContainVideoLanguage } from './Container/ContainVideoLanguage';
import { ContainWpoTopics } from './Container/ContainWpoTopics';
import { FC, ReactElement } from 'react';
import { IAnswerModel } from '../../../state/stores/Question/AnswerModel';
import { PresentChips } from './Presentation/PresentChips';
import { PresentChooseService } from './Presentation/PresentChooseService';
import { PresentConfirmSession } from './Presentation/PresentConfirmSession';
import { PresentCounsellors } from './Presentation/PresentCounsellors';
import { PresentDefault } from './Presentation/PresentDefault';
import { PresentDropdown } from './Presentation/PresentDropdown';
import { PresentSections } from './Presentation/PresentSections';
import { PresentVerifyText } from './Presentation/PresentVerifyText';
import { SnapshotOrInstance } from 'mobx-state-tree';

export interface AnswerSelectContainerProps extends AnswerSelectProps {
  question: IKeyedQuestion;
  onNext?: () => void;
  onPress: (answer: SnapshotOrInstance<IAnswerModel>) => void;
  children: (presentationState: AnswerSelectPresentationProps) => ReactElement;
}

export interface AnswerSelectPresentationProps {
  answers?: SnapshotOrInstance<IAnswerModel>[] | null;
  initSelected?: SnapshotOrInstance<IAnswerModel> | null;
  questionId: string;
  questionKey: string;
  onPress: (answer: SnapshotOrInstance<IAnswerModel>) => void;
  onNext?: () => void,
  labels?: Record<string, string | undefined>,
  loading?: boolean;
}

interface AnswerSelectConfig {
  Container?: FC<AnswerSelectContainerProps>;
  Presentation: FC<AnswerSelectPresentationProps>,
}

export const config: Record<string, AnswerSelectConfig> = {

  language: {
    Container: ContainLanguage,
    Presentation: PresentDropdown,
  },
  chooseService: {
    // Default container (no special pre-selection logic) — but a dedicated
    // presentation that surfaces the WPO description under each service name.
    Presentation: PresentChooseService,
  },
  assistanceMode: {
    Container: ContainAssistanceMode,
    Presentation: PresentDefault,
  },
  region: {
    Container: ContainRegion,
    Presentation: PresentDropdown
  },
  phoneCompanyRegionsCheck: {
    Container: ContainRegionInstantHelp,
    Presentation: PresentDropdown,
  },
  videocallCompanyRegionsCheck: {
    Container: ContainRegionInstantHelp,
    Presentation: PresentDropdown,
  },

  phoneLanguage: {
    Container: ContainPhoneLanguage,
    Presentation: PresentVerifyText,
  },
  videocallLanguage: {
    Container: ContainVideoLanguage,
    Presentation: PresentVerifyText
  },

  chooseTopics: {
    Container: ContainWpoTopics,
    Presentation: PresentChips,
  },

  chooseDate: {
    Container: ContainChooseDate,
    Presentation: PresentSections
  },
  chooseCounsellor: {
    Container: ContainCounsellors,
    Presentation: PresentCounsellors,
  },
  confirmSession: {
    Container: ContainConfirmSession,
    Presentation: PresentConfirmSession,
  },

};